import React from 'react'
import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { useState as uState, useEffect as uEffect } from "react";


export default function paymentTable() {
    const [data, setData] = uState([]);
    const [status, setStatus] = uState('')

    uEffect(() => {
        fetch("http://localhost:8000/order/orderPayment", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => response.json()).then((data) => setData(data));
    }, []);

    const handleSelectChange = (event) => {
        setStatus(event.target.value);
    };

    const handlePayment = (UserId) => {
        fetch("http://localhost:8000/order/payStatus", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                paymentStatus: status,
                userId: UserId
            })
        })
    };
    const filteredProducts = data.filter(product => product.hasOwnProperty('ProductTitle'));
    const user = data.filter(product => product.hasOwnProperty('PaymentStatus'));    
    function getRowId(filteredProducts) {
        return filteredProducts.OrderId;
    }
    const productColumns = [
        { field: "UserId"},
        { field: "OrderId", headerName: "OrderId", width: 150 },
        { field: "ProductTitle", headerName: "Title", width: 150 },
        { field: "ProductType", headerName: "Type", width: 120 },
        { field: "ProductQuantity", headerName: "Quantity", width: 120 },
        { field: "ProductAmount", headerName: "Amount", width: 120 },
    ];


    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 300,
            renderCell: (params) => {
                const { UserId } = params.row;
                return (
                    <div className="cellAction">
                        <form onSubmit={() => handlePayment(UserId)}>
                        <select className="deleteButton" value={status} onChange={handleSelectChange}>
                            <option>Select</option>
                            <option value="paid">Paid</option>
                            <option value="pending">Pending</option>
                            <option value="cancel">Cancelled</option>
                        </select>
                        <button type="submit" className="btn btn-success">
                            Update Status
                            </button>
                        </form>
                    </div>

                );
            },
        },
    ];
    return (
        <>

            <div className="datatable">
                {user && filteredProducts ?
                    user.map((item, index) => {
                        return (
                            <div key={index}>
                                <div className='d-flex justify-content-between' >
                                    <h6>UserId: {item.UserId}</h6>
                                    <h6>Email: {item.UserEmail}</h6>
                                    <h6>Total Amount: {item.TotalAmount}</h6>
                                    <h6>Payment Status: {item.PaymentStatus}</h6>
                                </div>                                            
                            </div>)
                    })                    
                    :
                    ''
                }
                <DataGrid
                    className="datagrid"
                    getRowId={getRowId}
                    rows={filteredProducts}
                    columns={productColumns.concat(actionColumn)}
                    pageSize={9}
                    rowsPerPageOptions={[9]}
                    checkboxSelection
                />
            </div>
        </>
    )
}
